import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { Estudo } from "../estudo/estudo";

@Component({
  selector: "comparacao-component",
  templateUrl: "./comparacao.component.html"
})
export class ComparacaoComponent implements OnInit{
  @Input() public list: Estudo[];
  @Input() estudosSelecionados: Estudo[];
  public mostarLista: boolean;


  constructor(
    private mensagem: MatSnackBar
  ) {

  }

  ngOnInit(){
    if(!this.list){
      this.mensagem.open("Lista deve possuir pelo menos dois estudos.", 'X', {duration: 5000});
    }

    this.mostarLista = true;
  }

  selecionarEstudo(estudosSelecionadosEmitido:Estudo[]){
    if(estudosSelecionadosEmitido && estudosSelecionadosEmitido.length != 2){
      this.mensagem.open("Selecione exatamente dois estudos.", 'X', {duration: 5000});
      estudosSelecionadosEmitido = null;
    }else{
      this.estudosSelecionados = estudosSelecionadosEmitido;
      this.mostarLista = false;
    }
  }

}
